// ref: da-mamba/Frontend/src/Areas/Mamba/Scripts/AngularEj/Data/Funnel/CurrencyPriority.d.ts
export enum CurrencyPriority {
  /** When currency doesn't come back from AVL (e.g. no flights), and we default to the website regional currency */
  InferredFromRegion_DEPRECATED = 1,

  /** The currency returned by flights from AVL (would not persist when changing searched route) */
  InferredFromRoute = 2,

  /** Locked to currency of selected flight (would persist when changing searched route) */
  SetBySelectedFlights_DEPRECATED = 3,

  /** Forced by deep link (can only be overridden by explicit user choice) */
  SetByDeepLink = 4,

  /** Explicitly picked via currency selector in UI */
  SetByUser = 5
}
